export function SortingManager () {
	var TABLE_SELECTOR = '#table'
	this.asc = true
	var prevAsc = null
	var currentAttribute = null
	var previousAttribute = null

	this.findActiveDirectionElements = function (attr, asc) {
		if (!attr) return null
		var inners = $(TABLE_SELECTOR + ' thead tr').find('.' + attr).find('.th-inner')
		return asc ? inners.find('.table_sort_asc') : inners.find('.table_sort_desc')
	}

	function clearActiveDirectionElementsStyle (elements) {
		if (!elements) return
		elements.removeClass('active-direction')
		elements.parent().removeClass('active-sort-col')
	}

	function addActiveDirectionElementsStyle (elements) {
		if (!elements) return
		elements.addClass('active-direction')
		elements.parent().addClass('active-sort-col')
	}

	this.stylizeSortControls = function () {
		var elements = this.findActiveDirectionElements(previousAttribute, prevAsc)
		clearActiveDirectionElementsStyle(elements)
		elements = this.findActiveDirectionElements(currentAttribute, this.asc)
		addActiveDirectionElementsStyle(elements)
	}

	this.setSortingConfig = function (config) {
		previousAttribute = currentAttribute
		prevAsc = this.asc
		currentAttribute = config.attr
		this.asc = config.asc
	}

	this.getSortingConfig = function () {
		var config = {}
		config.asc = this.asc
		config.attr = currentAttribute
		return config
	}

	this.getAttribute = function () {
		return currentAttribute
	}

	this.checkToNeedSorting = function (attr, asc) {
		return !(asc == this.asc && attr == currentAttribute)
	}

	this.makeSortable = function () {
		var sortControls = '<span class=\'sort-controls\'><span class=\'fa fa-caret-up table_sort_asc\'></span><span class=\'fa fa-caret-down table_sort_desc\'></span></span>'
		$(TABLE_SELECTOR + ' tr th').not('.bs-checkbox').not('.status').children('.th-inner').prepend(sortControls).addClass('sortable-header-th')
	}
}
